import { Gate, GateContext, GateDecision } from './gateTypes';

export const runGates = async (gates: Gate[], ctx: GateContext): Promise<GateDecision> => {
  for (const gate of gates) {
    const decision = await gate.check(ctx);
    if (!decision.allow) {
      return decision;
    }
  }
  return { allow: true };
};
